<script setup>
/* eslint-disable */
import { ref, computed } from 'vue';
import { BetSlip } from '@/stores/BetSlip';
import { useOddsStore } from '@/stores/odds';
import { useLanguagesStore } from '@/stores/languages';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import { useRouter } from 'vue-router';

const betslipStore = BetSlip();
const oddsStore = useOddsStore();
const languagesStore = useLanguagesStore();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const svg_data = ref(commonSvgs);
const router = useRouter();

const props = defineProps({
	betslip: {
		type: Object,
		default: null
	},
});

const isBetMultiple = () => {
	if (props.betslip?.betslip_type == "multiple") {
		return true;
	}

	if (!props.betslip && betslipStore.betslip.type == 'multiple') {
		return true;
	}

	return false;
}

const goToFixture = (bet) => {
	if (bet.odd_info.live) {
		router.push({ name: 'live-sports-eventview', params: { fixture_id: bet.odd_info.fixture_id } });
		return;
	}

	router.push({ name: 'pre-sports-fixturebook', params: { sport_id: bet.odd_info.sport_id, region_id: bet.odd_info.region_id, competition_id: bet.odd_info.competition_id, fixture_id: bet.odd_info.fixture_id } });
}


const calculateMultipleBetslipPrice = computed(() => {
	let price = 1;
	if (props.betslip) {
		for (const key in props.betslip.bets) {
			price = price * props.betslip.bets[key].odd_price;
		}
	} else {
		for (const bet_uuid in betslipStore.betslip.bets) {
			if (Object.hasOwnProperty.call(betslipStore.betslip.bets, bet_uuid)) {
				const bet = betslipStore.betslip.bets[bet_uuid];
				price = price * bet.odd_info.price;
			}
		}
	}

	return price.toFixed(2);
});

</script>
<template>
	<div v-if="props.betslip" v-for="bet in props.betslip.bets" :key="bet.uuid" class="bets_body">
		<div class="over_row" :style="bet.has_error ? 'display: grid; grid-template-columns: auto 1fr auto;' : '' ">
			<div class="circle" v-if="bet.has_error">
				<img v-if="bet.has_error" src="/assets/images/pink_circle_img.png" alt="icon">
			</div>
			<div class="left">
				<div class="top_content" :style="!bet.live ? '' : ''">
					<div class="live-badge" v-if="bet.live" v-html="svg_data.live_badge"></div>
					<div class="over">
						<p>{{ bet.odd_name }}</p>
					</div>
				</div>
				<div class="subtitle">
					<p>{{ bet.market_name }}</p>
				</div>
			</div>
			<div class="right">
				<div class="value">
					<p>{{ bet.sp ? bet.placeholder : oddsStore.oddsFormat(bet.odd_price) }}</p>
				</div>
			</div>
		</div>
		<div class="bottom_row">
			<div class="right">
				<div class="full_detail">
					<div v-if="(bet.region_name && bet.competition_name) || (bet.participants && bet.participants.length > 0)" class="icon">
						<svg class="normal-img" xmlns="http://www.w3.org/2000/svg" version="1.1" style="width:23px; height:23px; fill: none; stroke: var(--white);" viewBox="0 0 30 25">
							<use class="sprite-icon" :xlink:href="preSportsStore.preSportWhiteIcon(bet.sport_id) + '#svg3108'" stroke-width="1px" />
						</svg>
					</div>
					<div class="value">
						<div v-if="bet.region_name && bet.competition_name" class="title_top">
							<p>{{ bet.region_name }} - {{ bet.competition_name }}</p>
						</div>
						<template v-if="bet.participants && bet.participants.length > 0">
							<div v-if="liveSportsStore.hasOneParticipant(bet.sport_id) || bet.fixture_outright" class="title_bottom">
								<p>{{ bet.participants[0] }}</p>
							</div>
							<div v-else class="title_bottom">
								<p>{{ bet.participants[0] }} vs {{ bet.participants[1] }}</p>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else v-for="bet in betslipStore.betslip.bets" :key="bet.odd_info.uuid" class="bets_body">
		<div class="over_row" :style="bet.has_error ? 'display: grid; grid-template-columns: auto 1fr auto;' : '' ">
			<div class="circle" v-if="bet.has_error">
				<img v-if="bet.has_error" src="/assets/images/pink_circle_img.png" alt="icon">
			</div>
			<div class="left"  :class="{'suspended': bet.odd_info == null || bet.odd_info.status == 'suspended' }">
				<div class="top_content" :style="!bet.odd_info.live ? '' : ''">
					<div class="live-badge" v-if="bet.odd_info.live" v-html="svg_data.live_badge"></div>
					<div class="over">
						<p>{{ bet.odd_info.odd_name_translations[languagesStore.selectedSBLanguage.locale] }}</p>
					</div>
				</div>
				<div class="subtitle">
					<p>{{ bet.odd_info.market_name_translations[languagesStore.selectedSBLanguage.locale] }}</p>
				</div>
			</div>
			<div class="right">
				<div class="value" :class="{'betup': bet.odd_info.price > bet.price, 'betdown': bet.odd_info.price < bet.price, 'suspended': bet.odd_info == null || bet.odd_info.status == 'suspended' }">
					<p>{{ bet.odd_info.sp ? bet.odd_info.placeholder : oddsStore.oddsFormat(bet.odd_info.price) }}</p>
				</div>
			</div>
		</div>
		<div class="bottom_row">
			<!-- <div class="left" :class="{'suspended': betslipStore.processing_placement }" style="cursor:pointer;" @click="removeFromBetslip(bet)">
				<div class="img" v-html="svg_data.close"> </div>
			</div> -->
			<div class="right" @click="goToFixture(bet)">
				<div class="full_detail" :class="{'suspended': bet.odd_info == null || bet.odd_info.status == 'suspended' }">
					<div class="icon">
						<svg class="normal-img" xmlns="http://www.w3.org/2000/svg" version="1.1" style="width:23px; height:23px; fill: none; stroke: var(--white);" viewBox="0 0 30 25">
							<use class="sprite-icon" :xlink:href="preSportsStore.preSportWhiteIcon(bet.odd_info.sport_id) + '#svg3108'" stroke-width="1px" />
						</svg>
					</div>
				<div class="value">
					<div class="title_top">
						<p>{{ bet.odd_info.region_name_translations[languagesStore.selectedSBLanguage.locale] }} - {{ bet.odd_info.competition_name_translations[languagesStore.selectedSBLanguage.locale] }}</p>
					</div>
					<div v-if="liveSportsStore.hasOneParticipant(bet.odd_info.sport_id) || bet.odd_info.fixture_outright" class="title_bottom">
						<p>{{ bet.odd_info.fixture_participants_translations[languagesStore.selectedSBLanguage.locale][0] }}</p>
							</div>
						<div v-else class="title_bottom">
							<p>{{ bet.odd_info.fixture_participants_translations[languagesStore.selectedSBLanguage.locale][0] }} vs {{ bet.odd_info.fixture_participants_translations[languagesStore.selectedSBLanguage.locale][1] }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>



	</div>

	<div v-if="isBetMultiple()" class="bets_body">
		<div class="over_row">
			<div class="left">
				<div class="top_content">
					<div class="over">
						<p>{{$t('share_bet.accumulator')}} </p>
					</div>
				</div>
				<div class="subtitle">
					<!-- <p>{{ bet.market_name }}</p> -->
				</div>
			</div>
			<div class="right">
				<div class="value">
					<p><span class="spanaki">@</span>{{calculateMultipleBetslipPrice}}</p>
				</div>
			</div>
		</div>

	</div>
</template>
<style scoped>
.spanaki {
	color: var(--white);
}
.bets_body:first-child {
	margin-top: 15px ;
}

.bets_body {
	position: relative;
	padding: 10px 12px;
	background: var(--light-dark);
	margin-top: 5px;
}

.bets_body .over_row {
	grid-auto-columns: auto auto;
	grid-gap: 1%;
	grid-auto-flow: column;
	display: grid;
	justify-content: space-between;
	align-items: flex-start;
	text-align: center;
	padding-left: 0%;
	gap: 5px;
}

.bets_body .over_row .left {
	position: relative;
}

.bets_body .over_row .left .top_content {
	display: grid;
	grid-template-columns: auto auto;
	gap: 10px;
	align-items: center;
	text-align: center;
	justify-content: start;
}

.bets_body .over_row .left .top_content .over {
	font-size: 13px;
	font-weight: bold;
	color: var(--white);
	text-align: start;
	display: grid;
}

.bets_body .over_row .left .top_content .over p {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.bets_body .over_row .left .subtitle {
	font-size: 13px;
	color: var(--primary);
	text-align: start;
	display: grid;
	padding-top: 5px;
}

.bets_body .over_row .left .subtitle p {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.bets_body .over_row .right {
	font-size: 12px;
	font-weight: 500;
	color: var(--primary);
	text-align: right;
	display: flex;
	gap: 10px;
}

.bets_body .over_row .right .value {
	position: relative;
	margin-top: 0;
	font-weight: bold;
	font-size: 13px;
	/* margin-right: 10px; */
}

.bets_body .over_row .right .seprater {
	background: var(--tab-gray);
	height: auto;
	width: 1px;
}

.bets_body .over_row .right .clear-ico {
	display: flex;
	align-items: center;
}

.bets_body .over_row .right .clear-ico svg {
	height: 100%;
	cursor: pointer;
}

.bets_body .bottom_row {
	grid-auto-columns: 1fr;
	gap: 27px;
	grid-auto-flow: column;
	display: grid;
	justify-content: start;
	align-items: self-start;
	text-align: center;
	padding-top: 3px;
}

.bets_body .bottom_row .right {
	position: relative;
}

.bets_body .bottom_row .right .full_detail {
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 5px;
	align-items: center;
	text-align: center;
	justify-content: start;
	cursor: pointer;
}

.bets_body .bottom_row .right .full_detail .icon {
	height: 14px;
	width: 14px;
	position: relative;
	display: flex;
}

.bets_body .bottom_row .right .full_detail .value {
	position: relative;
}

.bets_body .bottom_row .right .full_detail .value .title_top {
	font-size: 12px;
	color: var(--white);
	text-align: start;
	margin-bottom: 1px;
	font-weight: 200;
}

.bets_body .bottom_row .right .full_detail .value div {
	display: grid;
}

.bets_body .bottom_row .right .full_detail .value .title_bottom {
	font-size: 10px;
	color: var(--white);
	text-align: start;
	font-weight: 200;
}

.bets_body .bottom_row .right .full_detail .value div p {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: normal;
	display: block;
}

.bets_body .over_row .left .top_content .live-badge {
	color: var(--dark);
	background: var(--secondary);
	border-radius: 3px;
	font-size: 9px;
	width: 38px;
	height: 15px;
	text-align: center;
	margin-top: 2px;
	font-weight: 600;
}

.bets_body .over_row .left .top_content .live-badge span {
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 0px;
	padding-bottom: 0;
	font-weight: 500;
}

.bets_body .over_row .left .top_content .live-badge span svg {
	margin-top: 0px;
	width: 10px;
}

.suspended {
	opacity: 0.2;
	pointer-events: none;
	cursor: not-allowed;
}
</style>